import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {PackCard} from "../types";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import NumField from "../../1. Core/Controls/TextField/NumField";
import ImageTextField from "../../1. Core/Controls/TextField/ImageTextField";


export default class EditPackCardDialog extends Dialog {
    private _PackCard: PackCard;
    private _name_en: TextField;
    private _name_ru: TextField;
    private _name_es: TextField;
    private _name_pt: TextField;
    private _backgroundColorInput: TextField;
    private _iconInput: ImageTextField;
    private _descInput: TextField;
    private _PackId: number;
    private _rowInput: NumField;
    private _colInput: NumField;

    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._PackId = null
        this._PackCard = {} as PackCard;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Card pack editor';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save';
        this._AutoDestroy = true;
    }

    _render() {
        super._render();


        this._name_en = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (en)'
        });
        this._name_ru = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (ru)'
        });
        this._name_es = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (es)'
        });
        this._name_pt = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (pt)'
        });

        this._backgroundColorInput = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Background color'
        });

        this._iconInput = new ImageTextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Icon image url'
        });

        this._descInput = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Description'
        });

        this._colInput = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Column'
        });

        this._rowInput = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Row'
        });


        this.refresh();
    }

    async refresh() {

        if (this._PackCard.id) {
            this._name_en.setValue(this._PackCard.name_en);
            this._name_ru.setValue(this._PackCard.name_ru);
            this._name_es.setValue(this._PackCard.name_es);
            this._name_pt.setValue(this._PackCard.name_pt);
            this._backgroundColorInput.setValue(this._PackCard.background_color);
            this._descInput.setValue(this._PackCard.description);
            this._iconInput.setValue(this._PackCard.icon_png);
            this._colInput.setValue(this._PackCard.grid_col);
            this._rowInput.setValue(this._PackCard.grid_row);
        } else {
            this._PackCard.pack_id = this._PackId
        }
    }

    async _onOkButtonClick() {

        this._PackCard.name_en = this._name_en.getValue();
        this._PackCard.name_ru = this._name_ru.getValue();
        this._PackCard.name_es = this._name_es.getValue();
        this._PackCard.name_pt = this._name_pt.getValue();
        this._PackCard.background_color = this._backgroundColorInput.getValue();
        this._PackCard.description = this._descInput.getValue();
        if (this._PackId)
            this._PackCard.pack_id = this._PackId
        this._PackCard.icon_png = this._iconInput.getValue();
        this._PackCard.grid_col = this._colInput.getValue();
        this._PackCard.grid_row = this._rowInput.getValue();

        if (this._PackCard.id) {
            await ServerAPI.put(`/fantasy/card-collections/cards/${this._PackCard.id}`, this._PackCard);
        } else {
            await ServerAPI.post(`/fantasy/card-collections/cards`, this._PackCard);
        }

        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
